import React from 'react';
import { fmtNum } from '@/lib/recuentos';

export const fmtStock = (v) => (v === null || v === undefined ? null : fmtNum(Math.round(v * 100) / 100));

const fechaCorta = (iso) => {
  const d = new Date(/[zZ]|[+-]\d\d:\d\d$/.test(iso) ? iso : `${iso}Z`);
  const p = Object.fromEntries(new Intl.DateTimeFormat('es-CL', { timeZone: 'America/Santiago', weekday: 'short', day: '2-digit', month: '2-digit' })
    .formatToParts(d).map((x) => [x.type, x.value]));
  return `${p.weekday.replace('.', '')} ${p.day}-${p.month}`;
};

export const StockLocalHeader = ({ info }) => (
  <th className="px-3 py-2 text-right align-top" data-testid="consol-stock-local-header">
    <div>Stock local</div>
    <div className="text-[10px] font-normal text-slate-400 leading-tight" data-testid="consol-stock-local-fecha">
      {!info ? 'Sin bodega del local' : <>{info.name}<br />{info.ultimo_ajuste ? `Recuento ${fechaCorta(info.ultimo_ajuste)}` : 'Sin recuento'}</>}
    </div>
  </th>
);

export const Leyenda = () => (
  <div className="flex flex-wrap gap-3 text-[11px] text-slate-500" data-testid="consol-leyenda">
    <span className="flex items-center gap-1"><span className="w-3 h-3 rounded bg-red-100 border border-red-300" /> Lo pedido supera el stock de Bodega Central</span>
    <span className="flex items-center gap-1"><span className="w-3 h-3 rounded bg-amber-100 border border-amber-300" /> El local ya tiene lo pedido o más</span>
    <span>s/d: sin dato en la bodega del local</span>
  </div>
);
